import React from 'react';

interface IconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const DraggableHandleIcon = ({ fill = '#818998', width = 12, height = 12 }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            d="M3.75 3C4.57843 3 5.25 2.32843 5.25 1.5C5.25 0.671573 4.57843 0 3.75 0C2.92157 0 2.25 0.671573 2.25 1.5C2.25 2.32843 2.92157 3 3.75 3Z"
            fill={fill}
        />
        <path
            d="M8.25 3C9.07843 3 9.75 2.32843 9.75 1.5C9.75 0.671573 9.07843 0 8.25 0C7.42157 0 6.75 0.671573 6.75 1.5C6.75 2.32843 7.42157 3 8.25 3Z"
            fill={fill}
        />
        <path
            d="M3.75 7.5C4.57843 7.5 5.25 6.82843 5.25 6C5.25 5.17157 4.57843 4.5 3.75 4.5C2.92157 4.5 2.25 5.17157 2.25 6C2.25 6.82843 2.92157 7.5 3.75 7.5Z"
            fill={fill}
        />
        <path
            d="M8.25 7.5C9.07843 7.5 9.75 6.82843 9.75 6C9.75 5.17157 9.07843 4.5 8.25 4.5C7.42157 4.5 6.75 5.17157 6.75 6C6.75 6.82843 7.42157 7.5 8.25 7.5Z"
            fill={fill}
        />
        <path
            d="M3.75 12C4.57843 12 5.25 11.3284 5.25 10.5C5.25 9.67157 4.57843 9 3.75 9C2.92157 9 2.25 9.67157 2.25 10.5C2.25 11.3284 2.92157 12 3.75 12Z"
            fill={fill}
        />
        <path
            d="M8.25 12C9.07843 12 9.75 11.3284 9.75 10.5C9.75 9.67157 9.07843 9 8.25 9C7.42157 9 6.75 9.67157 6.75 10.5C6.75 11.3284 7.42157 12 8.25 12Z"
            fill={fill}
        />
    </svg>
);
